import log from '@vcclive/log';
import { Middleware, ReducersMapObject } from 'redux';
import { Action } from '../interfaces/redux';

export function report(tag: string, error: Error, extra?: unknown) {
    log.error(error, { tag, extra });
}

export const errorMiddleware: Middleware = api => next => (action) => {
    try {
        return next(action);
    } catch (error) {
        const state = api.getState();
        report('Error in a middleware!', error as Error, { action, state });
        throw error;
    }
};

export function reportReducerError(reducers: ReducersMapObject): ReducersMapObject {
    const finalReducers: ReducersMapObject = {};
    Object.keys(reducers).forEach((key) => {
        finalReducers[key] = reducerWithErrorReporter.bind(null, reducers, key);
    });
    return finalReducers;
}

function reducerWithErrorReporter(reducers: ReducersMapObject, key: string, state: any, action: Action): any {
    try {
        return reducers[key](state, action);
    } catch (error) {
        report(`Error in reducer: ${key}`, error as Error, { action, state });
        return state;
    }
}
